import { render, staticRenderFns } from "./EvaluateLevels.vue?vue&type=template&id=fa546e84&"
import script from "./EvaluateLevels.vue?vue&type=script&lang=js&"
export * from "./EvaluateLevels.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateLevels.vue?vue&type=style&index=0&id=fa546e84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports